import { Component, ViewEncapsulation, ViewChild, inject } from '@angular/core';
import { PostTradeService } from '../../post-trade.service';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import capitalize from 'lodash-es/capitalize';
import { StringResult } from '../../../models/general-models';
import { SpecialCharacterDirective } from '../../../directives/special-character.directive';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-review-download-dialog',
  templateUrl: './review-download-dialog.component.html',
  styleUrls: ['./review-download-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    SpecialCharacterDirective,
  ],
})
export class ReviewDownloadDialogComponent {
  dialogRef = inject<MatDialogRef<ReviewDownloadDialogComponent>>(MatDialogRef);
  private ptSvc = inject(PostTradeService);
  data = inject(MAT_DIALOG_DATA);

  fileName = '';
  downloadRequested = false;
  categories = {
    trade: 'Transaction',
    account: 'Account',
    rep: 'FP',
    aml: 'AML',
  };

  downloadGridReport() {
    const { columns, rows, query } = this.data;
    const requestQuery = query;
    const requestCols = { columns };

    if (
      this.data.audit &&
      this.data.selectedRecords.length > 0 &&
      this.data.selectedRecords.length <= 1000
    ) {
      const recordList = [];

      this.data.selectedRecords.map(recordObj => {
        recordList.push(recordObj.TradeID);
      });

      if (recordList.length > 0) {
        delete requestQuery.take;
        delete requestQuery.skip;
        requestQuery['search']['TradeID'] = { selected: recordList };
      }

      this.ptSvc
        .generateAuditReport(
          this.fileName,
          encodeURIComponent(JSON.stringify(requestQuery)),
          encodeURIComponent(JSON.stringify(requestCols)),
          this.categories[this.data.gridType]
        )
        .subscribe((resp: StringResult) => {
          if (resp.result === 'Report request created') {
            this.downloadRequested = true;
          }
        });
    } else {
      if (requestQuery.take) {
        delete requestQuery.take;
      }
      if (requestQuery.skip) {
        delete requestQuery.skip;
      }

      this.ptSvc
        .generatePostTradeReviewReport(
          capitalize(this.data.gridType),
          this.fileName,
          encodeURIComponent(JSON.stringify(requestQuery)),
          encodeURIComponent(JSON.stringify(requestCols)),
          rows,
          this.categories[this.data.gridType]
        )
        .subscribe((resp: StringResult) => {
          if (resp.result === 'Report request created') {
            this.downloadRequested = true;
          }
        });
    }
  }
}
